import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_REPORT_ROUTE_COST_LOADING = 'GET_REPORT_ROUTE_COST_LOADING';
export const GET_REPORT_ROUTE_COST_SUCCESS = 'GET_REPORT_ROUTE_COST_SUCCESS';
export const GET_REPORT_ROUTE_COST_REJECT = 'GET_REPORT_ROUTE_COST_REJECT';

//* ACTIONS ------------------------------------------------
export const getReportRouteCostLoading = () => ({ type: GET_REPORT_ROUTE_COST_LOADING });
export const getReportRouteCostSuccess = (payload) => ({ type: GET_REPORT_ROUTE_COST_SUCCESS, payload });
export const getReportRouteCostReject = (payload) => ({ type: GET_REPORT_ROUTE_COST_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getReportRouteCostRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/Reports/GetAllRouteCostsBaseReport`, options);
};

